<template>
    <LayoutBase>
        <div class="full-height grid">
            <div id="content-wrapper" class="app-position">
                <div class="container-fluid">
                    <div class="row no-gutters">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <div class="article-wrapper">
                                <alert v-if="alert.copy" :type="alert.type" :title="alert.title" :copy="alert.copy"></alert>

                                <div class="panel">
                                    <header>
                                        <h1>Edit profile</h1>
                                    </header>

                                    <div class="form">
                                        <div class="form__group">
                                            <label class="form__label" for="name">Name</label>
                                            <input type="text" id="name" name="name" class="form__control" v-model="person.name">
                                        </div>

                                        <div class="form__group">
                                            <label class="form__label" for="email">Email</label>
                                            <input type="text" id="email" name="email" class="form__control" v-model="person.email">
                                        </div>

                                        <div class="form__group">
                                            <label class="form__label" for="job_title">Job title</label>
                                            <input type="text" id="job_title" name="job_title" class="form__control" v-model="person.job_title">
                                        </div>

                                        <div class="form__group">
                                            <label class="form__label" for="phone_office">Phone</label>
                                            <input type="text" id="phone_office" name="phone_office" class="form__control" v-model="person.phone_office">
                                        </div>

                                        <div class="form__group">
                                            <label class="form__label" for="phone_mobile">Mobile</label>
                                            <input type="text" id="phone_mobile" name="phone_mobile" class="form__control" v-model="person.phone_mobile">
                                        </div>

                                        <div class="form__group">
                                            <label class="form__label" for="intro">Intro</label>
                                            <textarea id="intro" name="intro" class="form__control" rows="5" v-model="person.intro"></textarea>
                                        </div>

                                        <div class="form__group">
                                            <label class="form__label" for="work_experience">Experience</label>
                                            <textarea id="work_experience" name="work_experience" class="form__control" rows="5" v-model="person.work_experience"></textarea>
                                        </div>

                                        <div class="form__group">
                                            <label class="form__label" for="avatar">Avatar</label>


                                            <a @click.prevent="openModal('avatar-media-library')" ref="btn" class="avatar avatar--large" v-if="person">
                                                <img :src="person.avatar" class="circle border border-white" v-if="person && person.avatar">
                                                <span class="initials circle border border-white" v-if="person && !person.avatar">{{ person.initials }}</span>
                                            </a>
                                        </div>

                                        <media-library
                                        name="avatar-media-library"
                                        :opened="modalOpened"
                                        @closedModal="onClosedModal"
                                        :group="group"
                                        :avatar=true
                                        :avatar_id="person.id"
                                        v-model="files" />


                                        <div class="form__group">
                                            <button class="btn btn-primary" v-on:click.stop.prevent="saveUser">Update profile</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                </div>
            </div>
        </div>
    </LayoutBase>
</template>

<script>
    import LayoutBase from '../../layouts/LayoutBase';
    import { mapState, mapGetters } from 'vuex';

    export default {
        components: {
            LayoutBase
        },
        data () {
            return {
                alert: {
                    type: null,
                    title: null,
                    copy: null
                },
                files: [],
                modalOpened: false,
                person: {},
            }
        },
        computed: {
            ...mapState({
                loggedInUser: state => state.auth.user,
            })
        },
        created() {
            this.getUser();
        },
        mounted() {
            
        },
        methods: {
            onClosedModal(){
                this.modalOpened = false;
                MicroModal.close('avatar-media-library')
            },
            openModal(modal, fileType = 'image'){
                this.modalOpened = true;
                MicroModal.show(modal);
            },
            getUser() {
                axios.get('/api/user/' + this.$route.params.user).then((response) => {
                    this.person = response.data;

                    if(this.loggedInUser.id === this.person.id){
                        this.$store.commit('auth/setUser', JSON.parse(JSON.stringify(response.data)));
                    }

                    // this.userReady();
                }, (response) => {
                    this.error = response;
                });
            },
            saveUser(e, silent = false){
                axios.put('/api/user/' + this.$route.params.user, this.person).then((response) => {
                    this.person = response.data;

                    if(this.loggedInUser.id === this.person.id){
                        this.$store.commit('auth/setUser', JSON.parse(JSON.stringify(response.data)));
                    }
                    
                    if(!silent){

                        if(this.loggedInUser.id === this.person.id){
                            this.alert.copy = [ "Your profile has been updated" ];  
                        }else{
                            this.alert.copy = [this.person.name + "'s profile has been updated"];
                        }
                        
                        this.alert.type = 'success';
                        window.scrollTo(0, 0);
                    }

                }, (response) => {
                    this.error = response;
                });
            },
        },
        watch: {
            files(files) {
                let token = document.head.querySelector('meta[name="csrf-token"]');
                if(typeof files[0] !== 'undefined' && token){
                    let img = files[0].url ?? files[0].urls.raw + "&q=80&w=180&h=180&fit=crop&crop=faces";
                    this.person.avatar = img;
                    this.saveUser(true);
                }
            }
        }
        // // Guard to protect route from none admins
        // beforeRouteEnter(to, from, next){
        //     if (!window.user_can.admin) next('/')
        //     else next()
        // }
    }
</script>

<style lang="scss" scoped>
    .avatar img {
        width: 90px;
        height: 90px;
        object-fit: cover;
        object-position: center;
    }
</style>